import { fetchGet } from './api'

export function getCurrentSystemVersion() {
  return fetchGet('/system/web/config/current-version', {})
}

export function getCurrentReleaseVersion() {
  return fetchGet('/system/release-version/current', {})
}

export function getReleaseVersionHistory(params) {
  return fetchGet('/system/release-version/history', params)
}

export function getReleaseVersionDetail(id) {
  return fetchGet('/system/release-version/get', { id })
}
